import React from "react";
import { ChevronDownIcon } from "@heroicons/react/outline";
import { NumberPicker } from "../numberPicker/numberPicker";
import Icon from '../../icon';
import NumericStepper from "../../numericStepper";
import { capitalizeFirstLetter } from "../../../utils/string";

export default class GuestPicker extends React.Component {
  state = {
    adults: [2],
    children: [],
    guestOpen: this.props.alwaysOpen === true ? true : false,
    numberOfRooms: 1
  };

  shouldComponentUpdate(prevProps, prevState) {
    if (this.state.adults !== prevState.adults) return true;
    if (this.state.children !== prevState.children) return true;
    if (this.state.guestOpen !== prevState.guestOpen) return true;
    if (this.state.numberOfRooms !== prevState.numberOfRooms) return true;
    return false;
  }

  open(ev){
    if(this.props.alwaysOpen === true) return;
    ev.preventDefault();
    this.setState({guestOpen: !this.state.guestOpen})
  }

  bodyClick = (ev) => {
    if (!ev.defaultPrevented && this.state.guestOpen) {
      this.open(ev);
    }
  }

  componentDidMount() {
    document.body.addEventListener('click', this.bodyClick);
  }
  componentWillUnmount() {
    document.body.removeEventListener('click', this.bodyClick);
  }

  addRooms(){
    const newAmountOfRooms = this.state.numberOfRooms + 1;
    const newAdults = [...this.state.adults];
    newAdults[this.state.numberOfRooms] = 2;
    this.setState({ adults: newAdults, numberOfRooms: newAmountOfRooms}, () => {
      this.props.onChange({adults: this.state.adults, childs: this.state.children.map(eachChildren => eachChildren.length), childAges: this.state.children, numberOfRooms: this.state.numberOfRooms })
    })
  }

  guestLabel(translations) {
    let adults = 0;
    let childs = 0;
    for (const adultsPerRoom of this.state.adults) { adults += adultsPerRoom; }
    for (const childsPerRoom of this.state.children) { childs += childsPerRoom.length; }
    if (childs > 0) return `${adults} ${translations.adults}, ${childs} ${translations.children}`;
    return `${adults} ${translations.adults}`;
  }

  render() {
    const colors = {
      primaryColor: '#fff',
      secondaryColor: '#2c2c2c',
      background: '#fff'
    }

    const { alwaysOpen, className, style = {}, customDivider, withChildAges = true, translations } = this.props;

    const divider = customDivider ? customDivider : <div className="w-full my-2 h-[1px]" style={{background: colors.primaryColor}}></div>

    return (
      <div className="relative w-full">
        <div className='flex w-full rounded-lg border px-3 relative' tabIndex={0} style={{background: this.state.guestOpen ? colors.background : colors.primaryColor, color: colors.secondaryColor, display: `${alwaysOpen && 'none'}`, ...style}} onClick={(ev) => this.open(ev)}
         onKeyDown={(e) => { if (e.nativeEvent.code === "Space" || e.nativeEvent.code === "Enter") this.open() }}>
          <div className="searchWidgetDetail absolute text-[#75757D] text-base duration-300 transform -translate-y-4 scale-75 origin-[0] bg-white px-2 px-2 top-2 scale-75 -translate-y-4 left-1">
            {translations.guests}
          </div>
          <div className="flex flex-row w-full items-center h-12 cursor-pointer">
            <div className="flex flex-col w-full">
              <div className="flex w-full pt-1">
                <span className={`${this.props.dateClass || ''} searchWidgetAnswerText`}>{this.guestLabel(translations)}</span>
              </div>
            </div>
            <ChevronDownIcon className="w-6 h-6 ml-auto" />
          </div>
        </div>

        {this.state.guestOpen && (
          <div 
            className={`${alwaysOpen ? 'w-full' : 'absolute drop-shadow'} w-full lg:w-[350px] top-[-130px] lg:top-[84px] left-0 rounded-lg p-4 z-10 flex flex-col gap-3 ${className}`} 
            onClick={(ev) => ev.preventDefault()} 
            style={{background: colors.background, ...style}}
            onKeyDown={(ev) => null}
            tabIndex={0}
          >
            {
              Array.from({length: this.state.numberOfRooms }, (_, index) => {
                return (
                  <React.Fragment key={`x-` + index}>
                    {this.state.numberOfRooms > 1 && <span className="font-[700] text-lg mt-6">{translations.room} {index + 1}</span>}
                    <div className="flex flex-row items-center">
                      <div className="flex-1 flex-col">
                        <div className="searchWidgetAnswerText"> {capitalizeFirstLetter(translations.adults)} </div> 
                        <div className='searchWidgetDetail text-[#75757D]'> {capitalizeFirstLetter(translations.age)} +13 </div>
                      </div>
                      <NumericStepper
                        quantity={this.state.adults[index]} min={1} max={12}
                        layout="rounded"
                        onChange={(value)=>{
                          if (value >= 0) {
                            const newAdults = [...this.state.adults];
                            newAdults[index] = value;
                            this.setState({ adults: newAdults }, () => {
                              this.props.onChange({adults: this.state.adults, childs: this.state.children.map(eachChildren => eachChildren.length), childAges: this.state.children, numberOfRooms: this.state.numberOfRooms })
                            })
                          }
                        }}
                        />
                    </div>
                    <div className="border-b" />
                    <div className="flex flex-row items-center">
                      <div className="flex-1 flex-col">
                        <div className="searchWidgetAnswerText">{capitalizeFirstLetter(translations.children)}</div> 
                        <div className='searchWidgetDetail text-[#75757D]'>{capitalizeFirstLetter(translations.ageDescriptionChildren.replace("{age}", "0-12"))} </div>
                      </div>
                      <NumericStepper
                        quantity={this.state.children[index] ? this.state.children[index].length : 0} min={0} max={12}
                        layout="rounded"
                        onChange={(value)=>{
                          if (value < 0) return;
                          const newValue = [...this.state.children];
                          if (!this.state.children[index] || value > this.state.children[index].length) {
                            if (!newValue[index]) newValue[index] = [];
                            newValue[index].push({age: 0});
                          } else {
                            newValue[index].pop();
                          }
                          this.setState({children: newValue}, () => {
                            this.props.onChange({adults: this.state.adults, childs: this.state.children.map(eachChildren => eachChildren ? eachChildren.length : 0), childAges: this.state.children, numberOfRooms: this.state.numberOfRooms })
                          })
                        }}
                        />
                    </div>
                    {withChildAges && this.state.children[index] && this.state.children[index].length > 0 && divider}
                    {withChildAges && this.state.children[index] && this.state.children[index].length > 0 && this.state.children[index].map((value, idx) => {
                      return (
                        <div key={idx}>
                          <NumberPicker
                            value={value.age ? value.age : 0}
                            title={`${translations.children} #${idx + 1}`}
                            description={translations.age}
                            updateValue={(value) => {
                              if (value < 0 || value > 12) return;
                              const newValue = [...this.state.children];
                              const innerArrayCopy = [...newValue[index]];
                              innerArrayCopy[idx].age = value;
                              newValue[index] = innerArrayCopy;
                              this.setState({ children: newValue }, () => {
                                this.props.onChange({adults: this.state.adults, childs: this.state.children.map(eachChildren => eachChildren ? eachChildren.length : 0), childAges: this.state.children, numberOfRooms: this.state.numberOfRooms })
                              })
                            }}
                          />
                        </div>
                      );
                    })}
                  </React.Fragment>
                )
              })
            }
            {
              this.props.maxRooms && this.state.numberOfRooms <= this.props.maxRooms
              ? <button onClick={() => this.addRooms() } className={`flex items-center gap-2 mt-4 font-[800] underline text-[color:var(--primaryColor)]`}>
                  <Icon icon="Plus" />
                  <span>{translations.addRoom}</span>
                </button>
              : null
            }
          </div>
        )}
      </div>
    );
  }
}
